import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const HowItWorks: React.FC = () => {
	const { translate } = useTranslate();
	return (
		<section className="how-it-works py-80">
			<Container>
				<Row className="how-it-works-row">
					<Col lg={5}>
						<div className="how-it-works-steps">
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									1
								</div>
								<p className="text-white mb-0 flex-1">
									{translate('Common.createBusinessAccount')}
								</p>
							</div>
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									2
								</div>
								<p className="text-white mb-0 flex-1">
									{translate('Common.createEmployerBranding')}
								</p>
							</div>
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									3
								</div>
								<p className="text-white mb-0 flex-1">{translate('Common.postJob')}</p>
							</div>
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									4
								</div>
								<p className="text-white mb-0 flex-1">{translate('Common.createMemberAccount')}</p>
							</div>
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									5
								</div>
								<p className="text-white mb-0 flex-1">{translate('Common.uploadResume')}</p>
							</div>
							<div className="step d-flex align-items-center">
								<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
									6
								</div>
								<p className="text-white mb-0 flex-1">{translate('Common.applyImmediately')}</p>
							</div>
						</div>
					</Col>
					<Col lg={7}>
						<div className="how-it-works-content">
							<div className="main-heading">
								<h2 className="fw-bold mb-3 mb-md-4">{parse(translate('Home.howItWorkTitle'))}</h2>
							</div>
							<div>
								<p>{translate('Home.howItWorkDescription1')}</p>
								<p>{parse(translate('Home.howItWorkDescription2'))}</p>
							</div>
							<Image
								src={IMAGE_PATHS.HowItWorksImg}
								className="how-it-works-img w-100 mt-0 mt-xxl-3 object-fit-cover"
								alt="how-it-works"
								loading="lazy"
							/>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default HowItWorks;
